import Resource from './resource';
import request from "../utils/request";

class QuestionCardAnswers extends Resource {
    constructor() {
        super('question_card_answers');
    }

    store(resource) {
        return request({
            url: `/question_card_answers/store`,
            method: 'post',
            data: resource
        });
    }

    bulkStore(resource) {
        return request({
            url: `/question_card_answers/bulk_store`,
            method: 'post',
            data: resource
        });
    }
}

export { QuestionCardAnswers as default };
